<ng-container *transloco="let t; read: 'accounts'">
<div class="fix-action-row modal-body">
  <div class="flex justify-between border-b">
    <h1 class="text-[20px] font-bold">{{ t('viewUser.profileTitle', { name: user.firstName + ' ' + user.lastName }) }}</h1>
    <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
  </div>

  <div mat-dialog-content>
    <div class="grid grid-cols-2 gap-4 gap-x-10 mt-5">
      <div class="mb-5">
        <h3 class="font-bold mb-2">{{ t('common.accountEmail') }}</h3>
        <p>{{user.emailName}}</p>
      </div>
      <div class="mb-5">
        <h3 class="font-bold mb-2">{{ t('common.accountStatus') }}</h3>
        <p>{{user.statusTypeName}}</p>
      </div>
    </div>

    <h2 class="text-[20px] font-bold mb-3">{{ t('viewUser.contactInformation') }}</h2>

    <div class="grid grid-cols-2 gap-4 gap-x-10">
      <div class="mb-5">
        <h3 class="font-bold mb-2">{{ t('common.name') }}</h3>
        <p>{{user.firstName + ' ' + user.lastName}}</p>
      </div>

      <div class="mb-5">
        <h3 class="font-bold mb-2">{{ t('common.workTitle') }}</h3>
        <p>{{user.jobTitle}}</p>
      </div>

      <div>
        <h3 class="font-bold mb-2">{{ t('viewUser.systemRoles') }}</h3>
        <!-- Server-supplied role names: localized by the API, not by Transloco. -->
        @for (role of user.roles; track role) {
          <p>{{role}}</p>
        }
      </div>
    </div>
  </div>
  <div mat-dialog-actions class="flex flex-row justify-end">
    <drdp-btn color="outline" mat-button mat-dialog-close>{{ t('common.close') }}</drdp-btn>
  </div>
</div>
</ng-container>
